<template>
  <app-section-wrap :modifier="'login update-password'">
    <div column="xl-3">
      <password-validator
        v-model="passwordValid"
        :newPassword="newPassword"
        :confirmNewPassword="confirmNewPassword"
      />
    </div>

    <div column="xs-12 s-12 m-6 xl-6 ">
      <div class="card">
        <h1 class="_text-center _mbxs">
          Update Password for {{userId}}
        </h1>
        <form @submit.prevent="updatePassword" method="POST">
          <div class="form-group">
            <label for="newPassword">
              New Password
            </label>
            <app-password-input
              class="_mbxs"
              id="newPassword"
              name="newPassword"
              value=""
              required
              v-model="newPassword"
            />
            <label for="confirmNewPassword">
              Confirm New Password
            </label>
            <app-password-input
              id="confirmNewPassword"
              name="confirmNewPassword"
              value=""
              required
              v-model="confirmNewPassword"
            />
          </div>
          <div v-if="authError" class="_flex justify-center">
            <p class="lips text">{{authMessage}}</p>
          </div>
          <async-button type="submit" class="_mtxs --sm" :executing="updatingPassword" :disabled="passwordValid || updatingPassword">
            <template #buttonContent>
              <span>Update Password</span>
            </template>
          </async-button>

        </form>
        <router-link
          :to="{name: 'user-view', params: { userId }}"
        >
          Back
        </router-link>
      </div>
    </div>

  </app-section-wrap>
</template>

<script>
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import PasswordValidator from '@organisms/PasswordValidator'
  import AppPasswordInput from '@atoms/PasswordInput'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      AppSectionWrap,
      AsyncButton,
      AppPasswordInput,
      PasswordValidator
    },
    data() {
      return {
        passwordValid: true,
        newPassword: '',
        confirmNewPassword: ''
      }
    },
    computed: {
      ...mapGetters([
        'authMessage',
        'authError',
        'updatingPassword',
        'requestingNewToken'
      ]),
      formObject() {
        return {
          newPassword: this.newPassword,
          userId: this.userId
        }
      },
      userId () {
        return this.$store.getters['hiddenRouteData/getHiddenRouteData'].userId
      }
    },
    methods: {
      updatePassword () {
        this.$store.dispatch('UPDATE_USER_PASSWORD', {
          body: this.formObject
        })
          .then(success => {
            if (success) { this.$router.push({ name: 'user-view', params: { userId: this.userId } }) }
          })
      }
    }
  }
</script>
